import { useContext } from "react"
import { useNavigate } from "react-router-dom"
import { Button } from "@nextui-org/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { LayoutContext } from "../../contexts/LayoutContext.jsx"
import { faArrowRightLong } from "@fortawesome/free-solid-svg-icons"

function SideNavItem({ navItem,customeclass }) {
  const { setShowSideNav } = useContext(LayoutContext)
  
  const navigate = useNavigate()
  const handleClickNav = () => {
    navigate(navItem.url)
    setShowSideNav(false)
  }
  
  return (
    <li>
      <Button
        radius="none"
        variant="light"
        to= { navItem.url}
        onPress={handleClickNav}
        startContent={navItem && navItem?.icon && <FontAwesomeIcon className="text-xs" icon={navItem?.icon} />}
      // startContent={navItem && navItem?.icon && <FontAwesomeIcon icon={faArrowRightLong  } />}
        className={`text-sm h-7 w-full flex justify-start 
         ${customeclass?customeclass:'border-b-0 border-b-gray-200 text-sky-900 border-l-2 border-l-orange-600  hover:bg-gradient-to-r from-sky-700 to-slate-50 hover:text-white'} `}
        //  bg-custom-nav-bg-color  text-custom-nav-text-color hover:bg-custom-bg-light hover:text-sky-700
      >
        {navItem.name}
      </Button>
    </li>
  )
}

export default SideNavItem
